import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import configureStore from './redux/store';
import HTTPSEnforcer from './utils/httpsEnforcer';

const initialState = {};
const store = configureStore(initialState);

// Initialize SSL/TLS security measures
HTTPSEnforcer.initialize();

const rootEl = document.getElementById('root');

if (rootEl) {
  ReactDOM.render(<App store={store} />, rootEl);
  serviceWorker.register();
}
